import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { authAPI } from "@/services/api";
import { getErrorMessage } from "@/utils/errorHelpers";
import { toast } from "sonner";

export default function ForgotPasswordPage() {
  const [params] = useSearchParams();
  const resetToken = params.get("token") || "";
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [supportMessage, setSupportMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const submitForgot = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await authAPI.forgotPassword({ email });
      toast.success("Si ce compte existe, un lien a ete envoye.");
    } catch (error) {
      toast.error(getErrorMessage(error, "Erreur de demande"));
    } finally {
      setLoading(false);
    }
  };

  const submitReset = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await authAPI.resetPassword({ token: resetToken, password });
      toast.success("Mot de passe reinitialise.");
      setPassword("");
    } catch (error) {
      toast.error(getErrorMessage(error, "Erreur de reinitialisation"));
    } finally {
      setLoading(false);
    }
  };

  const submitSupport = async () => {
    if (!email) {
      toast.error("Indiquez votre email de compte");
      return;
    }
    setLoading(true);
    try {
      await authAPI.passwordSupport({ email, message: supportMessage });
      toast.success("Demande transmise aux super-administrateurs.");
    } catch (error) {
      toast.error(getErrorMessage(error, "Erreur support"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FCFBF8] flex items-center justify-center p-6">
      <Card className="w-full max-w-md border-[#E6E4E0] shadow-lg">
        <CardHeader>
          <CardTitle className="text-2xl font-bold text-[#2A4B46] font-['Outfit']">
            {resetToken ? "Nouveau mot de passe" : "Mot de passe oublie"}
          </CardTitle>
          <CardDescription>
            {resetToken ? "Choisissez un mot de passe d'au moins 8 caracteres." : "Recevez un lien valable 15 minutes."}
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          {resetToken ? (
            <form onSubmit={submitReset} className="space-y-4">
              <div>
                <Label>Nouveau mot de passe</Label>
                <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} minLength={8} required className="mt-1" />
              </div>
              <Button type="submit" disabled={loading} className="w-full bg-[#2A4B46] text-white">
                {loading ? "Validation..." : "Reinitialiser"}
              </Button>
            </form>
          ) : (
            <>
              <form onSubmit={submitForgot} className="space-y-4">
                <div>
                  <Label>Email du compte</Label>
                  <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="mt-1" />
                </div>
                <Button type="submit" disabled={loading} className="w-full bg-[#2A4B46] text-white">
                  {loading ? "Envoi..." : "Envoyer le lien"}
                </Button>
              </form>

              <div className="border-t border-[#E6E4E0] pt-4 space-y-3">
                <p className="text-sm font-semibold text-[#2A4B46]">Plus accès a cet email ?</p>
                <Textarea value={supportMessage} onChange={(e) => setSupportMessage(e.target.value)} placeholder="Expliquez brievement votre situation..." />
                <Button type="button" variant="outline" onClick={submitSupport} disabled={loading} className="w-full">
                  Demander un support manuel
                </Button>
              </div>
            </>
          )}
          <div className="text-center text-sm">
            <Link to="/login" className="text-[#2A4B46] font-semibold hover:underline">Retour connexion</Link>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
